export default __webpack_public_path__ + "static/media/Polymers and Biosystems Engineering.0c78903e.pdf";